import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import API from "../services/api";
import "./Auth.css";

export default function Setup() {
  const { setIsConfigured } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    account_sid: "", auth_token: "", api_key: "",
    api_secret: "", twiml_app_sid: "", caller_id: "", tollfree_number: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await API.post("/twilio/credentials", form);
      setIsConfigured(true);
      navigate("/app/phone");
    } catch (err) {
      setError(err.response?.data?.error || "Failed to save credentials");
    }
    setLoading(false);
  };

  return (
    <div className="setup-page">
      <div className="setup-card">
        <div className="setup-header">
          <div className="setup-step">Step 1 of 1 · Credentials</div>
          <h1 className="setup-title">Connect your Twilio account.</h1>
          <p className="setup-desc">
            Your credentials are encrypted and stored per account.
            You can update them anytime in Settings.
          </p>
        </div>

        {error && <div className="msg-error" style={{ marginBottom: 16 }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="label">Account SID</label>
            <input value={form.account_sid} onChange={e => setForm(f => ({ ...f, account_sid: e.target.value }))} placeholder="ACxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx" required autoFocus />
          </div>
          <div className="form-group">
            <label className="label">Auth Token</label>
            <input type="password" value={form.auth_token} onChange={e => setForm(f => ({ ...f, auth_token: e.target.value }))} placeholder="••••••••••••••••" required />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="label">API Key SID</label>
              <input value={form.api_key} onChange={e => setForm(f => ({ ...f, api_key: e.target.value }))} placeholder="SKxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx" required />
            </div>
            <div className="form-group">
              <label className="label">API Secret</label>
              <input type="password" value={form.api_secret} onChange={e => setForm(f => ({ ...f, api_secret: e.target.value }))} placeholder="••••••••" required />
            </div>
          </div>
          <div className="form-group">
            <label className="label">TwiML App SID</label>
            <input value={form.twiml_app_sid} onChange={e => setForm(f => ({ ...f, twiml_app_sid: e.target.value }))} placeholder="APxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx" required />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="label">Caller ID (Regular Number)</label>
              <input value={form.caller_id} onChange={e => setForm(f => ({ ...f, caller_id: e.target.value }))} placeholder="+19177461556" required />
            </div>
            <div className="form-group">
              <label className="label">Toll-Free Number (optional)</label>
              <input value={form.tollfree_number} onChange={e => setForm(f => ({ ...f, tollfree_number: e.target.value }))} placeholder="+18887072570" />
            </div>
          </div>
          <button type="submit" className="btn btn-primary setup-btn" disabled={loading}>
            {loading ? <span className="spinner" /> : "Save & Launch UCaaS"}
          </button>
          <span className="setup-skip" onClick={() => navigate("/app/phone")}>
            Skip for now (configure later in Settings)
          </span>
        </form>
      </div>
    </div>
  );
}
